module.exports = __webpack_public_path__ + "img/mc-code.cfecc4df.png";